export interface DashboardRecoveryState {
  title: string;
  message: string;
  actionLabel: string;
  actionPath: string;
}

export function resolveDashboardRecoveryState(input: {
  leagueId: string | null;
  hasPlayer: boolean;
  hasLeagueAccess: boolean;
  hasSeason: boolean;
  role: 'admin' | 'player' | null;
}): DashboardRecoveryState | null {
  if (!input.hasPlayer) {
    return {
      title: 'Finish Player Setup',
      message: 'Your account is signed in, but it still needs to link to a player profile before league data can load.',
      actionLabel: 'Finish Setup',
      actionPath: '/',
    };
  }

  if (!input.hasLeagueAccess) {
    return {
      title: 'No League Access Yet',
      message: 'You are signed in, but you are not assigned to a league yet. Create a league, use an invite link, or ask a commissioner for access.',
      actionLabel: 'Review Account Setup',
      actionPath: '/',
    };
  }

  if (!input.hasSeason && input.leagueId) {
    if (input.role === 'admin') {
      return {
        title: 'No Active Season Selected',
        message: 'Create or activate a season before the dashboard can show standings, match days, and message-board activity.',
        actionLabel: 'Open Seasons',
        actionPath: `/leagues/${input.leagueId}/admin/seasons`,
      };
    }

    return {
      title: 'Season Not Ready Yet',
      message: 'This league does not have an active season selected right now. Ask a commissioner to activate one before weekly views can load.',
      actionLabel: 'Back to Dashboard',
      actionPath: '/leagues',
    };
  }

  return null;
}
